var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-xs-12 col-lg-6" }, [
      _c("h2", [_vm._v("Kunden-Login")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              _vm.uploadFile()
              _vm.event.preventDefault()
            },
          },
        },
        [
          _vm.hadError && !_vm.ajaxActive
            ? _c("div", { staticClass: "alert alert-danger" }, [
                _c("div", [
                  _vm._v(
                    "\n                Die Lizenzdatei war Fehlerhaft. Bitte versuchen Sie es erneut.\n              "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.ajaxActive
            ? _c("div", { staticStyle: { "margin-top": "2rem" } }, [
                _c("label", { staticClass: "btn", attrs: { for: "file" } }, [
                  _vm._v("Lizenzdatei hochladen"),
                ]),
                _vm._v(" "),
                _c("input", {
                  ref: "file",
                  staticStyle: {
                    visibility: "hidden",
                    opacity: "0",
                    "z-index": "-1",
                    position: "absolute",
                  },
                  attrs: { type: "file", id: "file" },
                  on: {
                    change: function ($event) {
                      return _vm.uploadFile()
                    },
                  },
                }),
              ])
            : _c("p", [
                _c("span", { staticClass: "fa fa-spin fa-spinner" }),
                _vm._v("\n                Lizenz wird geprüft\n            "),
              ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Melden Sie sich an, indem Sie Ihre Lizenz-Datei hochladen."),
      _c("br"),
      _vm._v("\n          Die Lizenz haben Sie von uns per Mail erhalten."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }